/**
 * Provider identities. HeyDex's own agent is the only driver (`heydex`) and runs
 * as the single instance of the same id. Threads, runs and persisted bindings
 * carry these ids; a stored id naming anything else is refused at admission.
 *
 * @module providerInstance
 */
import * as Schema from "effect/Schema";
import { TrimmedNonEmptyString } from "./baseSchemas.ts";

const slugSchema = TrimmedNonEmptyString.check(
  Schema.isMaxLength(64),
  Schema.isPattern(/^[a-zA-Z][a-zA-Z0-9_-]*$/),
);

export const ProviderDriverKind = slugSchema.pipe(Schema.brand("ProviderDriverKind"));
export type ProviderDriverKind = typeof ProviderDriverKind.Type;

export const ProviderInstanceId = slugSchema.pipe(Schema.brand("ProviderInstanceId"));
export type ProviderInstanceId = typeof ProviderInstanceId.Type;

export const HEYDEX_DRIVER_KIND = ProviderDriverKind.make("heydex");
export const HEYDEX_INSTANCE_ID = ProviderInstanceId.make("heydex");
